import { TTranslationFunction } from '@/types'

export const getColorPickerTranslations = (t: TTranslationFunction) => ({
	switchSolidModeLabel: t('ui__color_picker__mode_switch__solid'),
	switchPaletteModeLabel: t('ui__color_picker__mode_switch__palette'),
})
